export default __webpack_public_path__ + "static/media/kenisha.06b9adbf.png";